/**
 * @file index.tsx
 * @author liuchen(loocliu@tencent.com)
 */

import { setHexToRgba } from '@/utils/color';

import styles from './style/index.module.less';

interface ISendProps {
  msg: string;
  primary: string;
}

const Send = (props: ISendProps) => {
  const { msg, primary } = props;
  return (
    <div className={styles.root}>
      <div className={styles.msg} style={{ background: setHexToRgba(primary, 0.77) }}>
        {msg}
      </div>
    </div>
  );
};

export default (Send);
